// Auto-generated from the Magic UI library (https://magicui.design).
import { ComponentPropsWithoutRef, CSSProperties, FC } from 'react'

import { cn } from '@/lib/utils'

export interface AnimatedShinyTextProps
    extends ComponentPropsWithoutRef<'span'> {
    shimmerWidth?: number
    shimmerDuration?: string
}

export const AnimatedShinyText: FC<AnimatedShinyTextProps> = ({
    children,
    className,
    shimmerWidth = 100,
    shimmerDuration = '8s',
    ...props
}) => {
    return (
        <span
            style={
                {
                    '--shiny-width': `${shimmerWidth}px`,
                    '--shiny-duration': shimmerDuration,
                } as CSSProperties
            }
            className={cn(
                'text-neutral-600/70 dark:text-neutral-400/70',
                'animate-shiny-text bg-clip-text bg-no-repeat [background-size:var(--shiny-width)_100%]',
                'bg-gradient-to-r from-transparent via-black/80 via-50% to-transparent dark:via-white/80',
                className,
            )}
            {...props}
        >
            {children}
        </span>
    )
}
